import React from 'react';
import ScrollHint from '../ui/ScrollHint';

/**
 * The spine of the page: one conviction per screen, each snapping into place.
 * Deliberately text-only — the argument is the design.
 */
const POINTS = [
  {
    num: 1,
    title: 'AI Is the Operating Layer',
    desc: 'Bolting a chatbot onto a broken process only makes it fail faster. We start at the workflow, decide what intelligence genuinely belongs there, and build the layer that carries it.',
  },
  {
    num: 2,
    title: 'Pilots Are Not Progress',
    desc: 'A demo that wins the boardroom and never reaches production is a cost, not a capability. Everything we build is designed for the day it carries real users, real data and real volume.',
  },
  {
    num: 3,
    title: 'Weeks, Not Quarters',
    desc: 'Emerging tech moves faster than a planning cycle. We work in short sprints that each end with something running, so the next decision is argued from evidence instead of a slide.',
  },
  {
    num: 4,
    title: 'Your Team Owns What We Build',
    desc: 'We hand over systems your people can run, extend and explain. No black box, no permanent consultant, no dependency dressed up as a partnership.',
  },
  {
    num: 5,
    title: 'The Frontier Keeps Moving',
    desc: 'AI is the work today; spatial computing and on-chain provenance are already next. We build on foundations that survive the next shift rather than betting the business on one.',
  },
];

export default function Narrative() {
  return (
    <section className="narrative" id="narrative" aria-label="How Briva thinks">
      <ol className="container">
        {POINTS.map((point, i) => (
          <li className="narrative-point reveal" id={`point-${point.num}`} key={point.num}>
            <span className="point-num" aria-label={`Point ${point.num} of ${POINTS.length}`}>
              {String(point.num).padStart(2, '0')}
            </span>
            <h2>{point.title}</h2>
            <p>{point.desc}</p>
            <ScrollHint
              targetId={i < POINTS.length - 1 ? `point-${point.num + 1}` : 'capabilities'}
              label="Next"
            />
          </li>
        ))}
      </ol>
    </section>
  );
}
